<script setup>
import { useGlobalStore } from "@/store/modules/global";
import { useDelayRef } from "./utils/useDelayRef.js";
const global = useGlobalStore();
const router = useRouter();
const route = useRoute();
onMounted(() => {
  import("../src/assets/js/global/app.js");

  // if(route.name==='Login'|| route.name==='SSOLogin'){

  // }
});

const isLoading = useDelayRef(()=> global.isLoading || global.APIisLoading)
</script>

<template>
  <global-alert></global-alert>
  <router-view class="content-wrapper" />
  <global-loading
    v-if="isLoading"
  ></global-loading>
  <!-- <NotifyModal></NotifyModal> -->
</template>

<style>
@import "@/assets/css/igroup_fe.css";
</style>
<style lang="scss" rel="preload" src="./assets/all.scss"></style>
